import { useStore } from 'common/store';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import { getArrayValue } from 'utilities';
import { CapTableListSelectionProps } from './types';

const CapTableListSelection = ({ options: optionsProp, ...props }: CapTableListSelectionProps) => {
  const [{ capTableList = [] } = {}] = useStore() ?? [{}];

  const selectProps = {
    menuPosition: 'absolute',
    objectOptions: { displayKey: 'name', valueKey: 'id' },
    options: getArrayValue(optionsProp ?? capTableList),
    optionsTextAlign: 'right',
  };

  return <GridSelect {...props} {...selectProps} />;
};

export default CapTableListSelection;
